export default __webpack_public_path__ + "static/media/box-card2.dbc4be89.png";